module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popper', _vm._b({}, 'popper', _vm.optionsComputed, false), [_c('div', {
    staticClass: "popper"
  }, [_vm._v("\n    " + _vm._s(_vm.options.content) + "\n  ")]), _vm._v(" "), _vm._t("default", null, {
    "slot": "reference"
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16b5a4a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/PopOver.vue
// module id = 1824
// module chunks = 0